module.exports = __webpack_public_path__ + "static/media/btn-google-signin-light-normal.a0652b9a.svg";